<template>
  <div class="preview__iframe-wrapper">
    <div v-if="loading" class="word-mg-status" role="status">Cargando documento…</div>
    <div v-else-if="error" class="word-mg-status" role="alert">
      No se pudo mostrar el documento. Descárgalo con el botón de abajo.
    </div>
    <iframe
      v-else
      class="preview__iframe"
      title="Vista previa del documento Word"
      sandbox=""
      :srcdoc="documentHtml"
    />
  </div>
</template>

<script>
export default {
  name: 'PreviewWordMG',
  props: {
    url: { type: String, required: true },
  },
  data() {
    return { loading: true, error: false, documentHtml: '', controller: null }
  },
  mounted() {
    this.load()
  },
  beforeUnmount() {
    this.controller?.abort()
  },
  methods: {
    async load() {
      this.controller = new AbortController()
      try {
        const response = await fetch(this.url, {
          credentials: 'same-origin',
          signal: this.controller.signal,
        })
        if (!response.ok) throw new Error('No se pudo abrir el archivo')
        const data = await response.arrayBuffer()
        const { renderAsync } = await import('docx-preview')
        // Documento separado: los estilos del Word nunca afectan a Baserow.
        const container = document.createElement('div')
        await renderAsync(data, container, null, {
          useBase64URL: true,
          renderAltChunks: false,
          ignoreLastRenderedPageBreak: false,
        })
        container.querySelectorAll('[href]').forEach((el) => el.removeAttribute('href'))
        this.documentHtml = `<!doctype html><html lang="es-MX"><head>
          <meta charset="utf-8">
          <meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data:; font-src data:; style-src 'unsafe-inline'; base-uri 'none'; form-action 'none'">
          <style>body{margin:0}p,li{text-align:justify;text-justify:inter-word;hyphens:manual;-webkit-hyphens:manual}</style>
          </head><body>${container.innerHTML}</body></html>`
      } catch (error) {
        if (error.name !== 'AbortError') this.error = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.word-mg-status {
  padding: 32px;
  color: #fff;
  text-align: center;
}
</style>
